var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-input-percentage',_vm._g(_vm._b({attrs:{"value":_vm.base100Value},on:{"input":_vm.handleInput}},'m-input-percentage',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }